import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import User from "../services/user";
import Flow from "../services/flow.service";
import Storage from "../services/storage.service";

import Globals from "../services/globals";

import Translations from "../services/translation";
import Forms from "./forms.service";
// import Helpers from "../services/helpers";

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    subscriptions = [];

    state = {
      routeTo: null,
      url : null
    };

    constructor(props) {
      super(props);
      this.state = {
        component: null,
      };
    }

    async checkRoute() {
      if (Flow.isRouteAllowed(this.props.location.pathname, "1")) {

        // if (Flow.isSubPath(this.props.location.pathname)) {
        //   Storage.set("loading_text", "is sub");
        // } else {

        // }

        if (this.props.location.pathname !== Storage.get("loading_text")) {
          let stepkey = Flow.getStepNameByPath(this.props.location.pathname);
          if (stepkey && stepkey !== "account") {
            let strings = Translations["keys"][Translations.activeLang];
            let nn = strings["LOADING_MESSAGE_" + stepkey.toUpperCase()];
            Storage.set("loading_text", nn);
          }
        }

        const { default: component } = await importComponent();

        this.setState({
          component: component,
          routeTo: Flow.getCurrentRoute(),
        });
      } 
      else {
        let addressStepNumber = Storage.get("addressStepNumber");
        let recommended = Flow.getRecommendedRoute(2);
        let flow_status_order = Flow.pathNumberOf(recommended);
        let destination_order = Flow.pathNumberOf(this.props.location.pathname);
        let isSub = Flow.isSubPath(this.props.location.pathname);
        let forbidden_key = Flow.steps["" + destination_order]["key"];
        let forbidden_path = Flow.routes[forbidden_key]["path"];

        if (destination_order < flow_status_order) {
          // here is where the back flow navigation is altered and modified 
          // in each back click the step and route is specified
          const { default: component } = await importComponent();
          // if (destination_order > 1) {
            if(flow_status_order === 2){
              this.setState({
                routeTo: Flow.getStepBaseOf("plan"),
                component: component
              });
              Flow.goToRouteWithChecks("/plan-selection");
              return;
            }
            if(flow_status_order === 4){
              this.setState({
                routeTo: Flow.getStepBaseOf("number"),
                component: component
              });
              Flow.goToRouteWithChecks("/number");
            }
            if (flow_status_order === 5) {
              if (addressStepNumber === 1) {
                this.setState({
                  routeTo: Flow.getStepBaseOf("id_check"),
                  component: component
                });
                Storage.clear("is_resident");
                Storage.clear("is_resident_done");
                Storage.clear("addressStepNumber");
                Storage.clear("locationIsPicked");
                Storage.set("step", Flow.stepNumberOf("id_check"));
                Storage.clear("map_delivery_last_place");
                Storage.clear("addressLocation");
                Storage.clear("addressLatLang");
                flow_status_order = Flow.pathNumberOf("/residency");
                destination_order = Flow.pathNumberOf("/residency");
                Flow.goToRouteWithChecks("/residency");
              }
              if (addressStepNumber === 2) {
                this.setState({
                  routeTo: Flow.getStepBaseOf("delivery"),
                });
                Storage.clear("map_delivery_last_place");
                Storage.clear("locationIsPicked");
                Storage.clear("addressLatLang");
                Storage.set("addressStepNumber", 1, true);
                Storage.set("step", Flow.stepNumberOf("delivery"));
                flow_status_order = Flow.pathNumberOf("/address");
                destination_order = Flow.pathNumberOf("/address");
                Flow.goToStepBase("delivery");
              }
              if (addressStepNumber === 3) {
                this.setState({
                  routeTo: Flow.getStepBaseOf("delivery"),
                });
                Forms.inputChangedHandler("delivery", "", "location_type");
                Storage.set("addressStepNumber", 2, true);
                Storage.set("step", Flow.stepNumberOf("delivery"));
                flow_status_order = Flow.pathNumberOf("/address");
                destination_order = Flow.pathNumberOf("/address");
                Flow.goToStepBase("delivery");
              }
              return;
            }
            if(flow_status_order === 6){
              this.setState({
                routeTo: Flow.getStepBaseOf("id_check"),
                component : component
              });
                Storage.clear("is_resident");
                Storage.clear("is_resident_done");
                Storage.clear("delivery_form");
                Storage.clear("addressLocation");
                Storage.clear("locationIsPicked");
                Storage.clear("addressLatLang");
                Storage.clear("addressStepNumber");
                Storage.clear("map_delivery_last_place");
                Storage.set("step", Flow.stepNumberOf("id_check"));
                flow_status_order = Flow.pathNumberOf("/residency");
                destination_order = Flow.pathNumberOf("/residency");
                Flow.goToStepBase("id_check");
                return;
            }
            else {
              this.setState({
                routeTo: isSub
                  ? forbidden_path
                  : Flow.getPrevRouteOf(forbidden_key),
              });
            }
        } else {
          // console.log("Trying to go forward ..");
          this.setState({
            routeTo: isSub ? forbidden_path : recommended,
          });
        }
      }
    }

    async componentWillUnmount() {
      if (this.subscriptions) {
        for (let subscription of this.subscriptions) {
          subscription.unsubscribe();
        }
      }
      this.subscriptions = [];
      if (this.unlisten) {
        this.unlisten();
      }
    }
    async componentDidMount() {

      this.subscriptions.push(
        Flow.get_route().subscribe((data) => {
          if (data) {
            this.setState({
              routeTo: data,
            });
          }
        })
      );

      let flags = Storage.get("flow_status_flags");
      // if allowed route
      if (User.isLoggedIn()) {
        if (flags) {
          this.checkRoute();
        } else {
          User.flowStatus(2)
            .then((response) => {
              this.checkRoute();
            })
            .catch((error) => {
              // this.checkRoute();
              Globals.handleError(error, 49);
            });
        }
      } else {
        // console.log("not logged in ");
        this.checkRoute();
      }

      this.unlisten = this.props.history.listen((location, action) => {
        this.setState({
          url : location.pathname,
        });
      });
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (
        this.state.routeTo !== nextState.routeTo ||
        this.state.component !== nextState.component ||
        this.state.url !== nextState.url
      ) {
        return true;
      }
      return false;
    }
    render() {
      const C = this.state.component;
      let routeTo = null;
      if (this.state.routeTo) {
        routeTo = <Redirect to={this.state.routeTo} key={Date.now()} />;
      } else {
        routeTo = "";
      }
      return (
        <>
          {routeTo}
          {C ? <C {...this.props} /> : ""}
        </>
      );
    }
  }

  return AsyncComponent;
}
